import { Component } from '@angular/core';

@Component({
  selector: 'app-action-renderer',
  //imports: [],
  templateUrl: './action-renderer.component.html',
  styleUrl: './action-renderer.component.css',
  standalone:false
})
export class ActionRendererComponent {
   params: any;
  role = '';

 showMenu = false;
 checked = false;

agInit(params: any): void {
  this.params = params;

  const status = this.params.data.isActive;
  this.checked = status !== undefined
  ? (
      status === true ||
      status === 'true' ||
      status === 'Y' ||
      status === 1 ||
      status === '1'
    )
  : this.params.data.status === 'ACTIVE';
}

refresh(params: any): boolean {
  this.params = params;

  const status = this.params.data.isActive;
  return status !== undefined
  ? (
      status === true ||
      status === 'true' ||
      status === 'Y' ||
      status === 1 ||
      status === '1'
    )
  : this.params.data.status === 'ACTIVE';
}

  edit() {
    this.params.onEdit?.(this.params.data);
  }

  history() {
    this.params.onHistory?.(this.params.data);
  }

toggle(event: any) {
  this.checked = event.target.checked;
  this.params.onToggle?.(this.params.data, this.checked);
}

isChecked(): boolean {
  const status = this.params.data.isActive;

 return status !== undefined
  ? (
      status === true ||
      status === 'true' ||
      status === 'Y' ||
      status === 1 ||
      status === '1'
    )
  : this.params.data.status === 'ACTIVE';
}

view() {
  this.params.onView?.(this.params.data);
}

cancel() {
  this.params.onCancel?.(this.params.data);
}

download() {
  this.params.onDownload?.(this.params.data);
}

documents() {
  this.params.onDocuments?.(this.params.data);
}



toggleMenu(event: MouseEvent) {
  event.stopPropagation();
  this.showMenu = !this.showMenu;
}

revoke() {
  this.showMenu = false;
  this.params.onRevoke?.(this.params.data);
}

track() {
  this.params.onTrack?.(this.params.data);
}
}